import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return <div className="flex min-h-full w-full flex-col bg-parchment font-sans" data-id="element-24" data-mp="uzcjzyzqp47d">
      <SiteHeader data-id="element-25" data-mp="7874jkxpodxl" />
      <main className="flex-1 pt-20" data-id="element-26" data-mp="79rz3ak0zwvg">
        <Outlet data-id="element-27" data-mp="76m97t3koqyo" />
      </main>
      <SiteFooter data-id="element-28" data-mp="2a5pdb3eoyre" />
    </div>;
}